"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = SplitterTemplate;

var React = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Handle = _interopRequireDefault(require("../../components/Handle"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var keyStep = 5;

var SplitterContainer = _styledComponents["default"].div.withConfig({
  displayName: "SplitterTemplate__SplitterContainer",
  componentId: "sc-1cf39c8-0"
})(["display:flex;height:100%;flex:1 1 auto;"]);

var Pane = _styledComponents["default"].div.withConfig({
  displayName: "SplitterTemplate__Pane",
  componentId: "sc-1cf39c8-1"
})(function (props) {
  return (0, _styledComponents.css)(["overflow:", ";flex:", " auto;min-width:0;"], props.overflow, props.primary ? '0 0' : '1 1');
});
/**
### Layout template component
The **SplitterTemplate** is a layout component that divides the parent container into two panels. The ratio between the two panels can be adjusted by dragging the handle in between them. The component will render its first child in the left panel, and its second child in the right panel and the initial ratio can be set by the `initialWidth` prop. This value will be the width of the left panel in pixels.
 */


function SplitterTemplate(_ref) {
  var children = _ref.children,
      _ref$initialWidth = _ref.initialWidth,
      initialWidth = _ref$initialWidth === void 0 ? 0 : _ref$initialWidth,
      _ref$overflow = _ref.overflow,
      overflow = _ref$overflow === void 0 ? 'auto' : _ref$overflow,
      _ref$onResize = _ref.onResize,
      onResize = _ref$onResize === void 0 ? function () {} : _ref$onResize,
      _ref$onDragStart = _ref.onDragStart,
      onDragStart = _ref$onDragStart === void 0 ? function () {} : _ref$onDragStart,
      _ref$onDragEnd = _ref.onDragEnd,
      onDragEnd = _ref$onDragEnd === void 0 ? function () {} : _ref$onDragEnd;

  var _React$useState = React.useState(initialWidth),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      width = _React$useState2[0],
      setWidth = _React$useState2[1];

  var isResizing = React.useRef(false);
  var containerRef = React.useRef();
  var primaryPaneRef = React.useRef();
  var handleRef = React.useRef();

  function removeMouseEventListeners() {
    window.removeEventListener('mousemove', handleDrag);
    window.removeEventListener('mouseup', handleDragEnd);
    window.removeEventListener('touchmove', handleDrag);
    window.removeEventListener('touchend', handleDragEnd);
    window.removeEventListener('touchcancel', handleDragEnd);
  }

  function addMouseEventListeners() {
    window.addEventListener('mousemove', handleDrag);
    window.addEventListener('mouseup', handleDragEnd);
    window.addEventListener('touchmove', handleDrag);
    window.addEventListener('touchend', handleDragEnd);
    window.addEventListener('touchcancel', handleDragEnd);
  }

  function handleKeyDown(event) {
    var newValue = 0;

    switch (event.key) {
      case 'ArrowRight':
      case 'ArrowUp':
        newValue = width + keyStep;
        break;

      case 'ArrowLeft':
      case 'ArrowDown':
        newValue = width - keyStep;
        break;

      default:
        return;
    }

    onDragStart();
    handleDrag({
      clientX: newValue,
      keyboardNav: true
    });
    onResize(newValue);
  }

  function calcNewWidth(clientX, keyboardNav) {
    var mainRect = containerRef.current.getBoundingClientRect();
    var primaryRect = primaryPaneRef.current.getBoundingClientRect();
    var handleRect = handleRef.current.getBoundingClientRect();
    var cursorLocation = keyboardNav ? clientX : clientX - handleRect.width / 2 - primaryRect.left;
    var newWidth = Math.min(Math.max(0, cursorLocation), mainRect.width - handleRect.width);
    return newWidth;
  }

  function handleDrag(_ref2) {
    var clientX = _ref2.clientX,
        keyboardNav = _ref2.keyboardNav;
    var newWidth = calcNewWidth(clientX, keyboardNav);
    setWidth(newWidth);
  }

  function handleDragStart(_ref3) {
    var clientX = _ref3.clientX;

    if (!isResizing.current) {
      removeMouseEventListeners();
      isResizing.current = true;
      addMouseEventListeners();
    } else {
      handleDrag({
        clientX: clientX
      });
    }

    onDragStart();
  }

  function handleDragEnd(_ref4) {
    var clientX = _ref4.clientX;
    isResizing.current = false;
    removeMouseEventListeners();
    onDragEnd();
    if (clientX) onResize(calcNewWidth(clientX));
  }

  return /*#__PURE__*/React.createElement(SplitterContainer, {
    ref: containerRef
  }, /*#__PURE__*/React.createElement(Pane, {
    ref: primaryPaneRef,
    primary: true,
    style: {
      width: width
    },
    overflow: overflow
  }, children[0]), /*#__PURE__*/React.createElement(_Handle["default"], {
    ref: handleRef,
    cursor: "col-resize",
    onMouseDown: handleDragStart,
    onKeyDown: handleKeyDown,
    onKeyUp: handleDragEnd
  }), /*#__PURE__*/React.createElement(Pane, {
    overflow: overflow
  }, children[1]));
}